import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useStore } from "../lib/store";
import { getTurnstileToken } from "../lib/turnstile";

export default function Register() {
  const { register } = useStore();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const turnstile_token = await getTurnstileToken();
      const user = await register(email, password, name, turnstile_token);
      toast.success(`Welcome, ${user.name}`);
      nav("/account");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Registration failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="container-kv pt-32 pb-20 max-w-md mx-auto" data-testid="register-page">
      <div className="card-kv">
        <div className="overline mb-3">Join Kratoven</div>
        <h1 className="font-serif text-3xl mb-6 font-light">Create account</h1>
        <form onSubmit={submit} className="space-y-4">
          <Field label="Name" value={name} onChange={(e) => setName(e.target.value)} name="name" />
          <Field label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} name="email" />
          <Field label="Password (min 6)" type="password" value={password} onChange={(e) => setPassword(e.target.value)} name="password" minLength={6} />
          <button type="submit" disabled={busy} className="btn-gold w-full" data-testid="register-submit">
            {busy ? "Creating..." : "Create Account"}
          </button>
        </form>
        <p className="text-xs text-[#75726D] mt-5 text-center leading-relaxed">
          Protected by Cloudflare Turnstile · Email verification on first purchase.
        </p>
        <p className="text-sm text-[#A8A5A1] mt-6 text-center">
          Already a member? <Link to="/login" className="text-[#C8A97E] hover:underline">Sign in</Link>
        </p>
      </div>
    </div>
  );
}

function Field({ label, ...p }) {
  return (
    <div>
      <label className="text-xs text-[#75726D] uppercase tracking-widest mb-2 block">{label}</label>
      <input {...p} data-testid={`field-${p.name}`} required />
    </div>
  );
}
